<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_INNER_FUND_PER_RENTAL_OBJECT' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <app-information-block [text]="'REPORT.INFO.INNER_FUND_PER_RENTAL_OBJECT' | translate"></app-information-block>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <app-autocomplete-remote-paged
        [service]="companyService"
        [defaultSearch]="'*'"
        [control]="form.controls['company']"
      ></app-autocomplete-remote-paged>
      <astral-date-picker [control]="form.controls['periodFrom']"></astral-date-picker>
      <astral-date-picker [control]="form.controls['periodTo']"></astral-date-picker>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      @if (dataContext && dataContext.length) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          [labelKey]="!expandAllRows ? 'COMMON.EXPAND_ALL' : 'COMMON.COLLAPSE_ALL'"
          (click)="toggleExpandAllRows()"
        ></astral-button>
      }
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      [expandAllRows]="expandAllRows"
      [preferencesKey]="'report.brf-inner-fund'"
    ></app-expanded-list-view>
  }
</section>
